import React from 'react';
import PropTypes from 'prop-types';
import { checkRTL } from '@utils/rtlLanguageHoc';

function BulletList({ items }) {
  const isItemsRtl = checkRTL(items.join(''));
  return (
    <ul className={isItemsRtl ? 'rtl' : ''}>
      {items.map(item => (
        <li className="bullet-point mb-2" key={item}>
          {item}
        </li>
      ))}
    </ul>
  );
}

BulletList.propTypes = {
  items: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default BulletList;
